var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M34.333-643.609l-5.65-9.424a.731.731 0 0 0-1.367.009l-5.65 9.411c-.376.628-.095 1.114.624 1.114h11.419c.72 0 1-.482.625-1.109zM28-650.947c.362 0 .642.409.623.909l-.115 3.012c-.018.5-.248.908-.51.908s-.492-.409-.51-.908l-.113-3.012c-.018-.5.263-.909.625-.909zm0 7.1a.746.746 0 0 1-.76-.808.751.751 0 0 1 .76-.808.754.754 0 0 1 .769.808.754.754 0 0 1-.769.805z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M-201 0h1440v-837H-201z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    clipPath: "url(#clip-path)",
    transform: "translate(-21.5 653.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    fill: "#fff",
    d: "M16.5-658.5h23v21h-23z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.1eb3a9a6019501b9fd0cfd1e0f5f30d2.svg";
export { ForwardRef as ReactComponent };